module.exports = __webpack_public_path__ + "img/1.15127852.png";